// extracted by mini-css-extract-plugin
export default {"button_tutorial":"Tutorial_button_tutorial__MmHNc","button":"Tutorial_button__sgI20"};